import { Box } from "@chakra-ui/react";

const FAIcon = ({ variant = "solid", type = "question", ...rest }) => (
  <Box className={`fa-${variant} fa-${type}`} {...rest} />
);

export default FAIcon;
